import axios from "axios";
import { API_URL } from "../../constants";

export const MessageNoteApi = async (body) => {
    // ApiStatus({ isLoader: true, isError: false, data: null });
     const token = sessionStorage.getItem('LOGIN_TOKEN');
 
     try {
         let res = await axios.post("https://filmwings.com/site/notification/message",body, {
             headers: {
                 'Authorization': "Bearer " + token,
             }
         });
         //ApiStatus({ isLoader: false, isError: false, data: res.data });
     } catch (err) {
         //ApiStatus({ isLoader: false, isError: true, data: null });
     }
 
 }